<template>
  <div class="searchTypes">
    <span>Search by:</span>
    <button class="searchType" @click="setSearchType('all')">
      Upcoming
    </button>
    <button class="searchType" @click="setSearchType('current')">
      Already started
    </button>
    <button class="searchType" @click="setSearchType('unmatched')">
      Unmatched
    </button>
    <button class="searchType" @click="setSearchType('matched')">
      Matched
    </button>
    <button class="searchType" @click="setSearchType('bothjoined')">
      Both joined
    </button>
    <button class="searchType" @click="setSearchType('onehasjoined')">
      One has joined
    </button>
    <button class="searchType" @click="setSearchType('nonejoined')">
      No one has joined
    </button>
  </div>
</template>

<script>
export default {
  name: "SessionSearchTypes",
  methods: {
    setSearchType(type) {
      this.$emit("setSearchType", type);
    },
  },
};
</script>